<template>
  <svg :width="width" :height="height" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.12504 90.8708C3.74636 90.8708 4.25004 91.3745 4.25004 91.9958V96.9999H116V91.9958C116 91.3745 116.504 90.8708 117.125 90.8708C117.746 90.8708 118.25 91.3745 118.25 91.9958V97.2324C118.25 98.5207 117.082 99.2499 116.064 99.2499H4.18563C3.16826 99.2499 2.00004 98.5207 2.00004 97.2324V91.9958C2.00004 91.3745 2.50372 90.8708 3.12504 90.8708Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M104.662 80.2003C105.084 79.744 105.796 79.7159 106.252 80.1375L117.889 90.89C118.229 91.2043 118.341 91.6949 118.173 92.1262C118.004 92.5574 117.588 92.8412 117.125 92.8412H70.4379V94.4477C70.4379 95.069 69.9342 95.5727 69.3129 95.5727H51.895C51.2737 95.5727 50.77 95.069 50.77 94.4477V92.8412H3.12504C2.66675 92.8412 2.25427 92.5632 2.08228 92.1385C1.91028 91.7137 2.01314 91.227 2.34232 90.9082L13.443 80.1557C13.8893 79.7234 14.6015 79.7348 15.0338 80.1811C15.4661 80.6274 15.4547 81.3396 15.0084 81.7719L5.90343 90.5912H51.895C52.5164 90.5912 53.02 91.0949 53.02 91.7162V93.3227H68.1879V91.7162C68.1879 91.0949 68.6916 90.5912 69.3129 90.5912H114.25L104.725 81.7901C104.269 81.3684 104.241 80.6566 104.662 80.2003Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M54.7098 91.383C54.7098 90.7616 55.2135 90.258 55.8348 90.258H65.6413C66.2626 90.258 66.7663 90.7616 66.7663 91.383C66.7663 92.0043 66.2626 92.508 65.6413 92.508H55.8348C55.2135 92.508 54.7098 92.0043 54.7098 91.383Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.0323 24.5492C13.0323 22.589 14.6214 21 16.5815 21H103.669C105.629 21 107.218 22.589 107.218 24.5492V78.5395C107.218 80.4997 105.629 82.0887 103.669 82.0887H16.5815C14.6214 82.0887 13.0323 80.4997 13.0323 78.5395V24.5492ZM16.5815 23.25C15.864 23.25 15.2823 23.8317 15.2823 24.5492V78.5395C15.2823 79.257 15.864 79.8387 16.5815 79.8387H103.669C104.386 79.8387 104.968 79.257 104.968 78.5395V24.5492C104.968 23.8317 104.386 23.25 103.669 23.25H16.5815Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.7099 29.4526C16.7099 27.4924 18.2989 25.9034 20.2591 25.9034H99.9914C101.952 25.9034 103.541 27.4924 103.541 29.4526V73.6364C103.541 75.5966 101.952 77.1856 99.9914 77.1856H20.2591C18.2989 77.1856 16.7099 75.5966 16.7099 73.6364V29.4526ZM20.2591 28.1534C19.5416 28.1534 18.9599 28.735 18.9599 29.4526V73.6364C18.9599 74.354 19.5416 74.9356 20.2591 74.9356H99.9914C100.709 74.9356 101.291 74.354 101.291 73.6364V29.4526C101.291 28.735 100.709 28.1534 99.9914 28.1534H20.2591Z"
      fill="#05070F"
    />
    <path
      d="M26.761 42.0287L33.2821 35.3039C33.6666 34.9074 34.2997 34.8976 34.6962 35.2821C35.0926 35.6666 35.1024 36.2997 34.7179 36.6961L26.6935 44.9713L23.251 41.0789C22.8851 40.6652 22.9238 40.0332 23.3375 39.6673C23.7512 39.3014 24.3832 39.3402 24.7491 39.7539L26.761 42.0287Z"
      fill="#FF0064"
    />
    <path d="M40.1064 37.8779H67.3213M40.1064 44.8806H75.9155" stroke="#FF0064" stroke-width="2" stroke-linecap="round" />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'EmailVerificationIllustration',
  props: {
    width: {
      type: Number,
      default: 120,
    },
    height: {
      type: Number,
      default: 120,
    },
  },
};
</script>
